/* 🤖 this file was generated by svg-to-ts */
export const matIconNote: {
  name: 'note';
  data: string;
} = {
  name: 'note',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"/></svg>`
};
